module.exports = __webpack_public_path__ + "static/media/cook.3fc8f611.png";